import { ListItem } from './SelectMenuItem.styles.js';
import { type ListItemProps } from './types.js';
import { AddIcon } from '@contra/icons/icons';
import { forwardRef, type ReactNode, type Ref } from 'react';
import { styled } from 'styled-components';

const StyledListItem = styled(ListItem)`
  gap: 8px;
  justify-content: flex-start;
  color: ${({ theme }) => theme.colorsV2.gray70};
`;

const Child = styled.div`
  display: flex;
  flex: 1;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  border: 1px solid ${({ theme }) => theme.colorsV2.gray40};
`;

type SelectMenuItemProps = ListItemProps & {
  readonly children: ReactNode;
};

const SelectMenuCreateItem = forwardRef(
  (
    { children, color, isSelected, ...props }: SelectMenuItemProps,
    ref: Ref<HTMLLIElement>,
  ) => (
    <StyledListItem
      ref={ref}
      {...props}
      color={color as string}
      isSelected={isSelected}
    >
      <IconContainer>
        <AddIcon size={16} />
      </IconContainer>

      <Child>{children}</Child>
    </StyledListItem>
  ),
);

SelectMenuCreateItem.displayName = 'SelectMenu.CreateItem';

export { SelectMenuCreateItem };
